import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'
import { initMobileOptimizations } from './utils/performance'
// useWebVitals moved to Admin page only

// Initialize mobile optimizations immediately
initMobileOptimizations();

// Create a client with mobile-optimized settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 15, // 15 minutes — keep cached data ~3x staleTime
      retry: (failureCount, error) => {
        const maxRetries = window.innerWidth < 768 ? 1 : 2;
        return failureCount < maxRetries;
      },
      retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
    },
  },
});

// Performance monitoring wrapper - simplified for production
const AppWithVitals = () => {
  // Removed useWebVitals from global scope to prevent UI rendering issues
  return <App />;
};

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppWithVitals />
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>
);